<template>
    <div class="col-12 mx-auto">
        <page-title :title="$t('registers.mentors.title')" :showTitle="false"></page-title>
        <div class="card">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">
                    {{ $t('registers.mentors.title') }}
                </div>
            </div>

            <div class="card-header" v-if="showSettingsBtn">
                <button type="button" class="btn btn-primary btn-lg"
                        v-if="showNewButton && claims.mentor.create"
                        @click="goToCreate">
                    {{$t('buttons.create.btnText')}}
                </button>


                <button type="button" class="btn btn-primary btn-lg"
                        v-if="showExportTemplateButton"
                        @click="goToExportTemplate">
                    {{$t('buttons.exportTemplate.btnText')}}
                </button>
                <label>
                    <input type="checkbox" id="exportWithData" class="checkbox" v-if="showExportTemplateButton">
                    <span v-if="showExportTemplateButton">{{$t('checkboxes.exportWithData.cbText')}}</span>
                </label>

                <form enctype="multipart/form-data" method="post" id="importForm" class="inlineForm">
                    <div class="inlineForm">
                        <button type="button" class="btn btn-primary btn-lg"
                                v-if="showImportFromExcelButton && claims.mentor.create"
                                @click="selectImportFiles">
                            {{$t('buttons.importFromExcel.btnText')}}
                        </button>
                        <input type="file" id="importFile" class="selectFile" @change="goToImportFromExcel" />
                    </div>
                </form>

                <i class="fas fa-cogs pointer fa-2x float-right text-success"
                   v-if="showSettingsBtn"
                   @click.stop="changeGridSettings"
                   data-toggle="tooltip"
                   :title="settingsTooltipText"></i>

                <grid-user-settings ref="userSettings"
                                    :schemaModelFields="schemaModelFields"
                                    :componentName="componentName"
                                    :useLabelAsTitle="true"
                                    :showUserSettings="true"
                                    :gridOptions="userSettings"
                                    v-if="showUserSettingsForm"
                                    @saveGridSettings="saveGridSettings"
                                    @loadGridSettings="loadGridSettings"
                                    @deleteGridSettings="deleteGridSettings"
                                    @userSettingsChanged="userSettingsChanged">
                </grid-user-settings>

            </div>

            <div class="card-body">
                <div class="btn-toolbar justify-content-between mt-0 mb-2" role="toolbar">
                    <div class="form-inline col-6">

                    </div>

                    <div class="input-group">
                        <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                        <button class="btn btn-secondary" @click.stop="massSearch">
                            <i class="fas fa-search"></i>
                            {{ $t('buttons.search.btnText') }}
                        </button>
                        <button class="btn btn-secondary"
                                @click.stop="clearFilters">
                            <i class="fas fa-times"></i>
                            {{ $t('buttons.clearFilters.btnText') }}
                        </button>
                    </div>
                </div>

                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'count'"
                                  :schema-data="'items'"
                                  :page-size='defaultGridRows'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError">
                </kendo-datasource>

                <kendo-grid ref="grid"
                            :data-source-ref="'datasource1'"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :toolbar="toolbar"
                            :excel="gridOptions.excel"
                            :dataBound="dataBound">
                    <kendo-grid-column :field="'id'"
                                       :title="$t('registers.mentors.gridHeaders.id')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'name'"
                                       :title="$t('person.firstName')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'position'"
                                       :title="$t('person.position')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'directorate'"
                                       :title="$t('registers.mentors.gridHeaders.directorate')">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'institution'"
                                       :title="$t('registers.mentors.gridHeaders.institution')">
                    </kendo-grid-column>
                    <kendo-grid-column :template="btnsTemplate"
                                       field="btnsColumn"
                                       :reorderable="false"
                                       :title="$t('actions')"
                                       v-if="showBtns">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import store from '../../../store/store';
    import GridUserSettings from "../../../components/grid/UserSettings";
    import BtnsTemplate from "../../../components/grid/StandardBtnsTemplate";
    import PageTitle from '../../../components/common/PageTitle';
    import personalizationService from '../../../services/personalization.service';
    import JSZip from "jszip";
    import { KendoGridPageSize } from "../../../models/enums";
    import { mapGetters } from 'vuex';

    export default {
        props: {
            // ����������, ����� ������� �� ���������� � �������� �� ������� �����������
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: true,
                type: Boolean
            },
            showExportTemplateButton: {
                default: false,
                type: Boolean
            },
            showImportFromExcelButton: {
                default: false,
                type: Boolean
            },
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            }
        },
        components: {
            'grid-user-settings': GridUserSettings,
            PageTitle
        },
        data() {
            return {
                componentName: "MentorsRegisterGrid", // ������ �� ������������ �� �������� �� ������� �����������
                titleKey: 'registers.mentors.title', // ������ �� ������������ �� �������� �� ������� �����������
                defaultGridRows: this.$store.getters.defaultGridRows,
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                customSettingsLoaded: false,
                searchQuery: '',
                schemaModelFields: {
                    id: {
                        name: 'id',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.mentors.id'
                    },
                    name: {
                        name: 'name',
                        type: 'string',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'person.firstName'
                    },
                    position: {
                        name: 'position',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'person.position'
                    },
                    directorate: {
                        name: 'directorate',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.mentors.gridHeaders.directorate'
                    },
                    institution: {
                        name: 'institution',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.mentors.gridHeaders.institution'
                    }
                },
                rawHtml: "",
                transportSettings: {
                    read: {
                        url: `${store.getters.baseUrl}/api/mentor/list`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    editable: {
                        mode: 'popup', /* inline, popup */
                        window: {
                            title: this.$t('person.gridTitle'),
                            animation: true
                        },
                        move: true
                    },
                    excel: {
                        fileName: 'Mentors.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                    pdf: {
                        fileName: 'Mentors.pdf',
                        title: this.$t(this.titleKey),
                        subject: this.$t(this.titleKey),
                        creator: this.$store.userName,
                        allPages: false,
                        avoidLinks: true,
                        paperSize: 'A4',
                        margin: { top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' },
                        landscape: true,
                        repeatHeaders: true,
                        scale: 0.6
                    }
                },
                showUserSettingsForm: false
            }
        },
        methods: {
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            goToCreate(event) {
                this.$router.push('/registers/mentor/create');
            },
            goToEdit(args) {
                this.$router.push('/registers/mentor/edit/' + args.id);
            },
            editInTewTabBtnClick(args) {
                let routeData = this.$router.resolve({ name: 'mentorEdit', params: { id: args.id } })
                window.open(routeData.href, '_blank')
            },
            goToDetails(args) {
                this.$router.push('/registers/mentor/details/' + args.id);
            },
            detailsInTewTabBtnClick(args) {
                let routeData = this.$router.resolve({ name: 'mentorDetails', params: { id: args.id } })
                window.open(routeData.href, '_blank')
            },
            pdfExport(args) {
            },
            excelExport(args) {
            },
            goToExportTemplate() {
            },
            selectImportFiles() {
            },
            goToImportFromExcel(args) {
            },
            dataBound(e) {
                // This is needed for grid state save
                if (!this.customSettingsLoaded) {
                    this.loadGridSettings();
                }
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    this.saveState();
                    return kendo.stringify(options);
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            toolbarTemplate: function () {
                let templateHtml =
                    '<span>' +
                    '<a class="k-pager-refresh k-link k-button" title="Refresh"><span class="k-icon k-i-reload"></span></a>' +
                    '</span>';

                return kendo.template(templateHtml);
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns: [{
                            name: "edit",
                            text: "",
                            tooltip: this.$t('buttons.edit.tooltipText'),
                            class: 'btn btn-success',
                            icon: "fas fa-edit",
                            show: this.claims.mentor.update,
                            clickHandler: this.goToEdit
                        },
                        {
                            name: "editInNewTab",
                            text: "",
                            tooltip: this.$t('buttons.editInNewTab.tooltipText'),
                            class: 'btn btn-primary',
                            icon: "fas fa-pencil-alt",
                            show: this.claims.mentor.update,
                            clickHandler: this.editInTewTabBtnClick
                        },
                        {
                            name: "details",
                            text: "",
                            tooltip: this.$t('buttons.details.tooltipText'),
                            class: 'btn btn-info',
                            icon: "fas fa-eye",
                            show: this.claims.mentor.read,
                            clickHandler: this.goToDetails
                        },
                        {
                            name: "detailsInNewTab",
                            text: "",
                            tooltip: this.$t('buttons.detailsInNewTab.btnText'),
                            class: 'btn btn-primary',
                            icon: "fas fa-eye",
                            show: this.claims.mentor.read,
                            clickHandler: this.detailsInTewTabBtnClick
                        },
                            //     {
                            //     name: "pdfExport",
                            //     text: "",
                            //     tooltip: this.$t('buttons.pdfExport.tooltipText'),
                            //     class: 'btn btn-danger',
                            //     icon: "far fa-file-pdf",
                            //     show: true,
                            //     clickHandler: this.pdfExport
                            // },
                            //     {
                            //     name: "excelExport",
                            //     text: "",
                            //     tooltip: this.$t('buttons.excelExport.tooltipText'),
                            //     class: 'btn btn-success',
                            //     icon: "far fa-file-excel",
                            //     show: true,
                            //     clickHandler: this.excelExport
                            // },
                        ]
                    }
                };
            },
            gridSettingsChanged(componentName, name, value) {
                this.setColumnVisibilitySettings();
            },
            loadColumnsVisibilitySettings() {
                return this.$http.get('/api/personalization/' + this.componentName + '/getColumnVisibility'
                ).then((response) => {
                    if (response.data.settings === null) {
                        // ������� �������� ������� � �� � ������������� ���������. ����� ���� �� ������������
                        return;
                    }

                    let settings = [];
                    for (var i = 0; i < response.data.settings.length; i++) {
                        settings.push(response.data.settings[i].name)
                    }
                    for (const key in this.schemaModelFields) {
                        if (this.schemaModelFields.hasOwnProperty(key)) {
                            this.schemaModelFields[key].visible = settings.includes(key);
                        }
                    }

                    this.setColumnVisibilitySettings();
                }).catch(error => {
                    this.$vs.notify({
                        title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                        text: error.response.data.message
                            ? error.response.data.message
                            : (error.response.data
                                ? error.response.data
                                : (error.response.statusText ? error.response.statusText : error.message)),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            setColumnVisibilitySettings() {
                var grid = this.$refs.grid.kendoWidget();
                var columns = grid.columns;

                // restore columns visibility state using the stored values
                for (var i = 0; i < columns.length; i++) {
                    var column = columns[i];
                    if (this.schemaModelFields[column.field].visible) {
                        grid.showColumn(column);
                    } else {
                        grid.hideColumn(column);
                    }
                }
            },
            // This is needed for grid state save and mass search
            getGridOptions() {
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    return grid.getOptions();
                }
            },
            saveGridSettings() {
                const gridSettings = this.getGridOptions();
                const grid = this.$refs.grid.kendoWidget();
                if (gridSettings && grid) {
                    this.$refs.userSettings.setGridSettings(gridSettings);

                    personalizationService
                        .saveGridSettings(this.componentName, gridSettings)
                        .then(response => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                                text: this.$helpers.responseMessage(response),
                                color: 'success',
                                time: this.$store.getters.notificationDuration
                            });
                        })
                        .catch(error => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: this.$helpers.errorColor(error),
                                time: this.$store.getters.notificationDuration
                            })
                        });
                }
            },
            loadGridSettings() {
                personalizationService
                    .loadGridSettings(this.componentName)
                    .then(response => {
                        try {
                            var options = personalizationService
                                .mergePersonGridSettings(this.getGridOptions(), response.data.settings);

                            let grid = this.$refs.grid.kendoWidget();
                            if (options && grid) {
                                grid.setOptions(options);

                                if (options.pageable.size !== grid.dataSource.options.pageSize) {
                                    grid.dataSource.pageSize(options.pageable.size);
                                    grid.refresh();
                                }

                                const userSettingsEditor = this.$refs.userSettings;
                                if (userSettingsEditor) {
                                    userSettingsEditor.setGridSettings(grid.getOptions());
                                }
                            }

                            this.customSettingsLoaded = true;
                        } catch (e) {
                            this.customSettingsLoaded = true;
                        }
                    })
                    .catch(error => {
                        this.customSettingsLoaded = true;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            deleteGridSettings() {
                personalizationService
                    .delteGridSettings(this.componentName)
                    .then(response => {
                        this.$router.go();
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            userSettingsChanged(userSettings, pageSizeChanged) {
                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    try {
                        grid.setOptions(userSettings);
                        if (pageSizeChanged === true) {
                            if (userSettings.pageable.size === KendoGridPageSize.All) {
                                grid.dataSource.pageSize(this.$refs["datasource1"].kendoDataSource.total());
                            } else {
                                grid.dataSource.pageSize(userSettings.pageable.size);
                            }
                            grid.refresh();
                        }
                    } catch (e) {
                    }
                }
            },
            saveState() {
                personalizationService.saveState(this.componentName, this.getGridOptions());
            },
            loadState: function () {
                let stateSettings = personalizationService.getState(this.componentName);
                let options = personalizationService.mergeStateSettings(this.getGridOptions(), stateSettings)
                if (options) {
                    let grid = this.$refs.grid.kendoWidget();
                    if (grid) {
                        grid.setOptions(options);
                    }
                }
            },
            changeGridSettings() {
                this.showUserSettingsForm = !this.showUserSettingsForm;
            },
            clearFilters() {
                personalizationService.claerState(this.componentName);

                this.searchQuery = '';
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            // End
        },
        mounted: function () {
            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        computed: {
            token: function () {
                return store.getters.authToken;
            },
            userSettings() {
                let grid = this.$refs.grid.kendoWidget();
                return grid.getOptions();
            },
            toolbar: function () {
                return [{ name: 'excel', text: this.$t('buttons.excelExport.tooltipText') }]
            },
            ...mapGetters(['claims'])
        },
        watch: {
            customSettingsLoaded: function (val) {
                if (val === true) {
                    // this.loadState();
                }
            }
        },
        created: function () {
            window.JSZip = JSZip // Необходимо е за да работи експорта в excel
        },
    }
</script>

<style scoped>
    .btn {
        margin-right: 10px;
        margin-left: 5px;
    }

    .checkbox {
        margin-right: 5px;
    }

    .selectFile {
        display: none;
    }

    .inlineForm {
        display: inline;
    }
</style>
